import { createUserManager } from "redux-oidc";
import { WebStorageStateStore } from "oidc-client";

const redirectUri = process.env.REACT_APP_REDIRECT_URI;
const userManagerConfig = {
  authority: "",
  client_id: "aml_client_ac",
  client_secret: "^&88xA9.N7%sk~A8",
  redirect_uri: redirectUri,
  response_type: "code",
  scope: "openid profile roles offline_access",
  // silent_redirect_uri: silentRedirectUri,
  silent_redirect_uri: `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ""}/silent_renew.html`,
  monitorSession: false,
  automaticSilentRenew: true,
  filterProtocolClaims: false,
  loadUserInfo: false,
  post_logout_redirect_uri: `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ""}/`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  revokeAccessTokenOnSignout: true,
};
let userManager = null;

export const userManagerFactory = () => {
  if (userManager === null) {
    const authorityUrl = localStorage.getItem("authorityUrl");
    userManagerConfig.authority = authorityUrl;
    userManager = createUserManager(userManagerConfig);
  }
  if (localStorage.getItem("authorityUrl") !== userManager.settings.authority) {
    const authorityUrl = localStorage.getItem("authorityUrl");
    userManagerConfig.authority = authorityUrl;
    userManager = createUserManager(userManagerConfig);
  }

  if (userManager.settings.authority === null) {
    userManager.settings.authority = localStorage.getItem("authorityUrl");
  }
  userManager.events._accessTokenExpired.cancel();
  userManager.events._accessTokenExpiring.cancel();
  return userManager;
};



// WEBPACK FOOTER //
// ./src/services/oidc/utils/userManager.js